import './front.scss';
import { StatsFront } from './StatsFront.js';

document.querySelectorAll( '.stats-block' ).forEach( ( element ) => {
	new StatsFront( element );
} );
